import React, { useState, useEffect } from 'react';

import Search from './components/Search';



const TnVed = ({TnvedOpen}) => {



    return (
        <>

            <div className={`w-[100%] h-[100%] mx-auto pt-[10px] px-[10px] sm:px[20px] font-medium`}
            style={{
                backgroundColor: '#fff'
            }}>
                <Search TnvedOpen={TnvedOpen}/>
            </div>
        </>
    );
};

export default TnVed;